(function () {
  'use strict';

  var TARGET_SELECTOR = '.bss-b2b-price-no-vat, .bss-b2b-price-vat';
  var SUFFIX_REGEX = /^(.+?)\s+((excl|incl)[\s\-]?btw)\s*$/i;
  var STYLE_ID = 'adeqo-card-suffix-style';
  var SUFFIX_CLASS = 'adeqo-card-suffix';

  function escapeHTML(s) {
    var div = document.createElement('div');
    div.textContent = s == null ? '' : String(s);
    return div.innerHTML;
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.' + SUFFIX_CLASS + '{font-size:12px;font-weight:400;color:#999;letter-spacing:.01em;margin-left:8px;vertical-align:baseline}';
    document.head.appendChild(style);
  }

  function process() {
    var els = document.querySelectorAll(TARGET_SELECTOR);
    if (els.length === 0) return;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector('.' + SUFFIX_CLASS)) continue;
      var text = (el.textContent || '').trim();
      var m = text.match(SUFFIX_REGEX);
      if (!m) continue;
      var amount = m[1].trim();
      var suffix = m[2].trim();
      el.innerHTML = escapeHTML(amount) +
        '<span class="' + SUFFIX_CLASS + '">' + escapeHTML(suffix) + '</span>';
    }
  }

  function init() {
    injectStyles();
    process();
    var observer = new MutationObserver(function () { process(); });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
